import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const ItemList = styled.div `
  display: grid;
  gap: 16px 0;
  grid-template-columns: repeat(12, 1fr);
  margin-top: var(--sectionMargin); 

  @media ${from(Device.MobileLarge)} {
    gap: 32px;
  }

  @media ${from(Device.TabletLarge)} {
    margin: 20px 0 0;
  }

  @media ${from(Device.DesktopSmall)} {
    justify-content: center;
    margin-top: 20px;
    transition: none;
  }
`;
const Item = styled.div `
  grid-column: span 12;
  height: 100%;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 6;
  }

`;
export default {
    Item,
    ItemList,
};
